import React from 'react';
import { motion } from 'framer-motion';
import { Star, ArrowLeft, Video, Phone, MoreVertical, Paperclip, Camera, Mic, Smile } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Carla, gracias por este ebook. Después de meses de tristeza, ahora mi esposo y yo hablamos como antes. Las risas volvieron a nuestro hogar. 🙏',
    name: 'María Elena',
    age: 42,
    city: 'Miami, FL',
    time: '10:42 a. m.',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
  }, {
    quote: 'Pensé que todo estaba perdido. Pero seguí el método y hoy siento que recuperamos la complicidad que nos unió.',
    name: 'Ana Cristina',
    age: 38,
    city: 'Houston, TX',
    time: '2:15 p. m.',
    avatar: 'https://randomuser.me/api/portraits/women/68.jpg'
  }, {
    quote: 'Esta guía me ayudó a entender que el problema no era mi esposo ni yo, sino la desconexión. Ahora nos sentimos más cerca que nunca.',
    name: 'Patricia R.',
    age: 35,
    city: 'New York, NY',
    time: '9:30 a. m.',
    avatar: 'https://randomuser.me/api/portraits/women/55.jpg'
  }, {
    quote: 'Carla, no tengo palabras para agradecerte. Los microgestos cambiaron todo. Mi esposo volvió a mirarme con amor y yo volví a sentirme valorada. ❤️',
    name: 'Carmen Sofia',
    age: 44,
    city: 'Los Angeles, CA',
    time: '5:45 p. m.',
    avatar: 'https://randomuser.me/api/portraits/women/32.jpg'
  }, {
    quote: 'No necesité terapia ni confrontaciones. Solo seguí los pasos y vi cómo nuestro matrimonio renacía día a día.',
    name: 'Isabella M.',
    age: 36,
    city: 'Chicago, IL',
    time: '12:20 p. m.',
    avatar: 'https://randomuser.me/api/portraits/women/71.jpg'
  }];
  return <section className="py-12 md:py-16 bg-white overflow-hidden" style={{
    paddingTop: "44px",
    paddingBottom: "44px"
  }} data-id="element-465">
      <div className="max-w-6xl mx-auto px-6" data-id="element-466">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-467">
          <span className="inline-block px-8 py-3 mb-4 text-2xl md:text-3xl font-bold tracking-wider text-[#9d4b6b] uppercase bg-[#9d4b6b]/10 border-b-4 border-[#9d4b6b]/30" data-id="element-468">
            Testimonios
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-[#2d2d2d] mb-4" data-id="element-469">
            Personas reales, resultados reales
          </h2>
          <p className="text-xl text-[#5a5a5a]" data-id="element-470">
            Mira lo que dicen quienes ya leyeron nuestro ebook junto con los
            bonos.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-471">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`flex flex-col items-center ${index === testimonials.length - 1 ? 'md:col-span-2 md:max-w-md md:mx-auto' : ''}`} data-id="element-472">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-473">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-474" />)}
              </div>

              {/* WhatsApp Card */}
              <div className="w-full bg-[#e5ddd5] rounded-lg shadow-xl overflow-hidden border border-gray-200 max-w-md mx-auto transform hover:scale-[1.02] transition-transform duration-300" data-id="element-475">
                {/* Header */}
                <div className="bg-[#075e54] text-white p-3 flex items-center justify-between shadow-md" data-id="element-476">
                  <div className="flex items-center gap-3" data-id="element-477">
                    <ArrowLeft className="w-5 h-5" data-id="element-478" />
                    <div className="w-9 h-9 bg-gray-300 rounded-full flex items-center justify-center overflow-hidden" data-id="element-479">
                      <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" data-id="element-480" />
                    </div>
                    <div className="flex flex-col" data-id="element-481">
                      <span className="font-medium text-sm leading-tight" data-id="element-482">
                        {item.name}
                      </span>
                      <span className="text-[10px] opacity-90" data-id="element-483">en línea</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-4" data-id="element-484">
                    <Video className="w-5 h-5" data-id="element-485" />
                    <Phone className="w-4 h-4" data-id="element-486" />
                    <MoreVertical className="w-4 h-4" data-id="element-487" />
                  </div>
                </div>

                {/* Chat Area */}
                <div className="p-4 min-h-[180px] flex flex-col justify-end bg-[url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png')] bg-opacity-10" data-id="element-488">
                  <div className="bg-white p-3 rounded-lg rounded-tl-none shadow-sm self-start max-w-[90%] relative mb-2" data-id="element-489">
                    <p className="text-[#303030] text-sm leading-relaxed mb-1" data-id="element-490">
                      {item.quote}
                    </p>
                    <span className="text-[10px] text-gray-500 float-right mt-1 ml-2" data-id="element-491">
                      {item.time}
                    </span>
                  </div>
                </div>

                {/* Input Area */}
                <div className="bg-[#f0f0f0] p-2 flex items-center gap-2" data-id="element-492">
                  <div className="bg-white rounded-full flex-1 px-4 py-2 flex items-center gap-2 shadow-sm" data-id="element-493">
                    <Smile className="w-5 h-5 text-gray-400" data-id="element-494" />
                    <span className="text-gray-400 text-sm flex-1" data-id="element-495">
                      Escribe un mensaje...
                    </span>
                    <Paperclip className="w-5 h-5 text-gray-400" data-id="element-496" />
                    <Camera className="w-5 h-5 text-gray-400" data-id="element-497" />
                  </div>
                  <div className="w-10 h-10 bg-[#008a7c] rounded-full flex items-center justify-center shadow-sm text-white" data-id="element-498">
                    <Mic className="w-5 h-5" data-id="element-499" />
                  </div>
                </div>
              </div>

              {/* User Info */}
              <div className="mt-4 flex items-center gap-3" data-id="element-500">
                <div className="w-10 h-10 bg-[#9d4b6b]/10 rounded-full flex items-center justify-center text-[#9d4b6b] font-bold text-lg" data-id="element-501">
                  {item.name.charAt(0)}
                </div>
                <div className="text-left" data-id="element-502">
                  <p className="font-bold text-[#2d2d2d]" data-id="element-503">{item.name}</p>
                  <p className="text-sm text-[#8b6f6f]" data-id="element-504">
                    {item.age} años • {item.city}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}